import React from "react";
import Logo from '../images/Logo.png';
import { Link } from "react-router-dom";

function Navbar(){

    
    function handleScroll(){
        const navbar = document.querySelector(".Navbar");
        if(window.scrollY !== 0){
            // navbar.classList.add("p-5");
            navbar.classList.add("m-5");
        }
        else{
            // navbar.classList.add("w-full");
            // navbar.classList.remove("p-5");
            navbar.classList.remove("m-5");
        } 
        
    }
    document.addEventListener("scroll",handleScroll);
    

    function handleClick(){
        const ele = document.querySelector(".Nav");
        const i = document.querySelector(".icon");
        if(ele.classList.contains("hidden")){
            ele.classList.remove("hidden");
        }
        else{
            ele.classList.add("hidden");
        }
        if(i.classList.contains("fa-bars")){
            i.classList.remove("fa-bars");
            i.classList.add("fa-x");
        }
        else{
            i.classList.remove("fa-x");
            i.classList.add("fa-bars");
        }
        // console.log(ele.classList);
    }
    return (
        // Settings for Lg
        <div className="flex bg-transparent backdrop-blur-lg top-0 sticky z-20">
            <div className="Navbar flex flex-col lg:flex-row w-full p-5 justify-between rounded-2xl shadow-md shadow-[#3383fc] bg-white flex-wrap transition-all ease-linear duration-200">
                <div className="flex justify-between">
                    <img className="w-40 md:w-72 h-auto" src={ Logo } alt="Logo"/>
                    <i onClick={handleClick} className="icon lg:hidden flex flex-col justify-center fa-solid fa-bars fa-xl hover:bg-slate-100 rounded-full p-5 md:p-4 h-1/2 my-auto"></i>
                </div>
                <div className="hidden lg:flex justify-center Nav select-none">
                    <ul className="flex flex-col lg:flex-row gap-x-8 text-center">
                        <li className="flex flex-col justify-center p-2"><Link className="text-black hover:text-[#2f77bb] transition duration-300 ease-in-out text-xl md:text-2xl lg:text-3xl font-light" to="/">Home</Link></li>
                        <li className="flex flex-col justify-center p-2"><Link className="text-black hover:text-[#2f77bb] transition duration-300 ease-in-out text-xl md:text-2xl lg:text-3xl font-light" to="/about">About</Link></li>
                        <li className="flex flex-col justify-center p-2"><Link className="text-black hover:text-[#2f77bb] transition duration-300 ease-in-out text-xl md:text-2xl lg:text-3xl font-light" to="/courses">Courses</Link></li>
                        <li className="flex flex-col justify-center p-2"><Link className="text-black hover:text-[#2f77bb] transition duration-300 ease-in-out text-xl md:text-2xl lg:text-3xl font-light" to="/contact">Contact</Link></li>
                        <li className="flex flex-col justify-center p-2"><Link className="bg-[#3383fc] hover:bg-[#141619] text-slate-950 hover:text-slate-100 transition duration-300 ease-in-out  text-xl md:text-2xl lg:text-3xl rounded-xl font-light" to="https://wa.me/9146035689"><button className="w-32 h-14">Enquiry</button></Link></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Navbar;